module.exports = __webpack_public_path__ + "static/media/smWhite.ea0734ec.png";